/**
 * JSON Schema for the new layout request parameters integrated with skeleton and modules.
 *
 * http://json-schema.org/
 */
export default {
  id: "layoutConfigSchema",
  type: "object",
  properties: {
    initialCarousel: {
      type: "number",
      min: 0,
      required: false
    },
    finalCarousel: {
      type: "number",
      minimum: 1,
      required: false
    },
    carouselsByPosition: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "number",
            minimum: 0
          },
          minItems: 1
        },
        {
          type: "number",
          minimum: 0
        }
      ]
    },
    carouselsById: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "number",
            minimum: 1
          },
          minItems: 1
        },
        {
          type: "number",
          minimum: 1
        }
      ]
    },
    avoidCache: { type: "boolean" },
    avoidCacheFor: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "number",
            minimum: 0
          },
          minItems: 1
        },
        {
          type: "number",
          minimum: 0
        }
      ]
    }
  },
  dependencies: {
    finalCarousel: ["initialCarousel"]
    //avoidCacheFor: ["avoidCache"]
  }
};
